module.exports = globalThis.__PLADA_MODULES__["react"];